import { Form, Formik, FormikHelpers } from 'formik';
import { updateApplicationStatusSchema } from '../../../schemas';
import AcademiaButton from '../Buttons/AcademiaButton';
import AcademiaTextAreaField from '../Inputs/AcademiaTextAreaField';
import ParentModal from './ParentModal';

const ApplicationConsentModal = ({
  subTitle,
  status,
  handleModalClose,
  mutationHandler,
}: {
  subTitle: React.ReactNode;
  handleModalClose: () => void;
  status: 'approved' | 'rejected' | 'resubmit';
  mutationHandler: (values: any, actions: FormikHelpers<any>) => void;
}) => {
  // rendering application consent modal component here
  return (
    <ParentModal onClick={handleModalClose}>
      <div className='space-y-3'>
        <div>
          <h2 className='text-2xl font-light capitalize text-base-dark-green'>
            Are you{' '}
            <span className='text-base-orange font-semibold'>sure?</span>
          </h2>

          <p className='text-left whitespace-pre-wrap text-base-dark-blue'>
            {subTitle}
          </p>
        </div>

        <Formik
          initialValues={{ status, comments: '' }}
          validationSchema={updateApplicationStatusSchema}
          onSubmit={mutationHandler}
        >
          {(props) => (
            <Form>
              <AcademiaTextAreaField
                name='comments'
                label='Add Comment'
                placeholder='Type the reasons behind your action here...'
                isRequired
              />

              <div className='flex items-center justify-center md:justify-end gap-3 !mt-5'>
                <AcademiaButton
                  type='submit'
                  variant='success'
                  customWidth={150}
                  isLoading={props.isSubmitting}
                >
                  Yes
                </AcademiaButton>

                <AcademiaButton
                  onClick={handleModalClose}
                  type='button'
                  customWidth={150}
                  variant='danger'
                >
                  No
                </AcademiaButton>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </ParentModal>
  );
};

export default ApplicationConsentModal;
